module.exports = __webpack_public_path__ + "img/GAME_FINDSAMEPICTURE1.2f374d91.jpg";